import React, { useState, useEffect } from 'react'
import { i18nTranslate } from 'src/utils'
import { checkoutContainer } from 'src/models'
import './styles.scss'
import { Row } from 'react-bootstrap'

const PaymentInstallment = () => {
  const [isInstallmentCheckboxSelefted, setIsInstallmentCheckboxSelefted] =
    useState(false)
  const hasInstallmentOptions =
    checkoutContainer.globalPaymentInstallmentsResponse &&
    Object.keys(checkoutContainer.globalPaymentInstallmentsResponse).length > 0

  useEffect(() => {
    if (!isInstallmentCheckboxSelefted) {
      checkoutContainer.updateCheckoutInstallmentFrequency('')
    }
  }, [isInstallmentCheckboxSelefted])

  return (
    <>
      <Row className="checkout-installment-wrapper">
        {hasInstallmentOptions && (
          <>
            <div className="checkbox-checkout-installment">
              <input
                tabIndex={0}
                type="checkbox"
                id="onetime-payment-installment"
                onClick={() => setIsInstallmentCheckboxSelefted(prev => !prev)}
              />
              <label htmlFor="onetime-payment-installment">
                <span>
                  {i18nTranslate(
                    'checkout.paymentInstallment',
                    'Payment In Installment'
                  )}
                </span>
              </label>
            </div>
            {isInstallmentCheckboxSelefted && (
              <select
                className="frequency-drpdown-checkout-installment"
                onChange={e =>
                  checkoutContainer.updateCheckoutInstallmentFrequency(
                    e.target.value
                  )
                }>
                <option value="">
                  {i18nTranslate(
                    'checkout.paymentInstallmentFrequency',
                    'Select Frequency'
                  )}
                </option>
                {Object.keys(
                  checkoutContainer.globalPaymentInstallmentsResponse
                ).map((item, index) => (
                  <option key={item + index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            )}
          </>
        )}
      </Row>
      {hasInstallmentOptions && (
        <div className="installment-info mt-2">
          {i18nTranslate(
            'checkout.paymentInstallmentInfo',
            'Interest rates according to Simple Installment'
          )}
        </div>
      )}
    </>
  )
}

export default PaymentInstallment
